import { permissions } from '../constants/permissions';

import { IUserAccess } from '~/modules/auth/interfaces/IUserAccess';
import { IResale } from '~/modules/resales/interfaces/IResale';

export function getUserPermissionsIds(
  currentAccess: IUserAccess,
  resale: IResale
): string[] {
  let permissionsIds = currentAccess.permissionGroup?.permissionIds || [];

  if (resale?._id) {
    permissionsIds = permissionsIds.filter(
      (permission) =>
        permission !== permissions.OFFERS.LIST &&
        permission !== permissions.OFFERS.UPDATE &&
        permission !== permissions.OFFERS.CREATE
    );
  }

  const shouldRenderOperationAreas =
    resale?.type === 'whiteLabel' && resale?.workWithOperatingArea;

  if (!shouldRenderOperationAreas) {
    permissionsIds = permissionsIds.filter(
      (permission) =>
        permission !== permissions.OPERATING_AREAS.LIST &&
        permission !== permissions.OPERATING_AREAS.CREATE &&
        permission !== permissions.OPERATING_AREAS.UPDATE &&
        permission !== permissions.OPERATING_AREAS.UPDATE_STATUS
    );
  }

  return permissionsIds;
}
